<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		// mounted(){
		// 	this.removeClea();
		// },
		// methods:{
		// 	removeClea(){
		// 		localStorage.clear();
		// 	}
		// }
	}
</script>

<style lang="scss">
	@import "./styles/app.scss";
	@media screen and (max-width: 1025px){
	  html, body {
			font-size: 80px !important; 
			#inp{
						left: 4.46rem !important;
						bottom: .12rem !important;
					}
			} }
	@media screen and (max-width: 320px){
	  html, body {
			font-size: 71px !important; } }
	@media screen and (min-width: 321px) and (max-width: 375px){
	  html, body {
			font-size: 85px !important; } }
	
	@media screen and (min-width: 376px) and (max-width: 414px){
		html, body {
		font-size: 94px !important; } }
</style>


// WEBPACK FOOTER //
// App.vue?79434c0a